import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { EMAIL_TEMPLATES_ACTIONS } from "../../../../redux/emailTemplates/actions";
import { EMAIL_TEMPLATE_TYPES_ACTIONS } from "../../../../redux/emailTemplateTypes/actions";
import {
  selectEmailTemplates,
  emailTemplateCreating,
  emailTemplatesFilters,
  emailTemplatesLoaded,
  emailTemplatesMeta,
  selectActiveEmailTemplate
} from "../../../../redux/emailTemplates/selectors";
import EmailTemplatesForm from "../../../forms/EmailTemplatesForm";
import Confirm from "../../../../base/Confirm";
import ListView from "../../../../base/ListView";
import { selectEmailTemplateTypes } from "../../../../redux/emailTemplateTypes/selectors";

class _EmailTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailTemplates: this.props.emailTemplates,
      emailTemplatesLoaded: this.props.emailTemplatesLoaded,
      baseFilters: {
        "page[number]": 1,
        "page[size]": 50,
        sort: "-updated_at",
        "filter[event_id]": this.props.event.id
      }
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    emailTemplates: PropTypes.array,
    emailTemplatesLoaded: PropTypes.bool,
    match: PropTypes.object,
    createEmailTemplate: PropTypes.func,
    updateEmailTemplate: PropTypes.func,
    deleteEmailTemplate: PropTypes.func,
    emailTemplateCreating: PropTypes.bool,
    emailTemplatesMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object,
    loadEmailTemplate: PropTypes.func,
    activeEmailTemplate: PropTypes.object,
    resetActive: PropTypes.func,
    loadEmailTemplateTypes: PropTypes.func,
    emailTemplateTypes: PropTypes.array
  };

  UNSAFE_componentWillMount() {
    this.props.updateFilters(this.state.baseFilters);
    this.props.loadEmailTemplateTypes();

    if (this.props.match.params.emailTemplateId) {
      this.props.loadEmailTemplate(this.props.match.params.emailTemplateId);
    } else {
      this.props.resetActive();
    }
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.emailTemplateId !==
      nextProps.match.params.emailTemplateId
    ) {
      this.props.loadEmailTemplate(nextProps.match.params.emailTemplateId);
    }
  }

  _handleCreate(values) {
    const data = {
      eventId: this.props.event.id,
      body: values.body,
      filename: "ja",
      type: values.type,
      subject: values.subject
    };

    this.props.createEmailTemplate(data);
  }

  _handleUpdate(values) {
    const data = {
      eventId: this.props.event.id,
      body: values.body,
      filename: "ja",
      type: values.type,
      subject: values.subject
    };

    this.props.updateEmailTemplate(values.id, data);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this emailTemplate? This action can not be undone, please make sure no festival is using this emailTemplate.",
      {
        title: "Delete EmailTemplate",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteEmailTemplate(id);
      },
      result => {}
    );
  }

  render() {
    const {
      emailTemplatesMeta,
      filters,
      emailTemplateCreating,
      event,
      emailTemplates,
      activeEmailTemplate,
      emailTemplateTypes
    } = this.props;

    const usedTypes = emailTemplates.map(template => template.type);
    const filteredTypes = emailTemplateTypes.filter(
      type => usedTypes.indexOf(type.type) === -1 && !type.global
    );

    const types = Object.entries(filteredTypes).map(type => type[1].type);

    const listViewConf = {
      dataSet: emailTemplates,
      dataMeta: emailTemplatesMeta,
      columns: [
        {
          key: "type",
          value: "Type",
          sort: "type"
        }
      ],
      baseFilters: filters,
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/events/" + event.id + "/email-templates"
    };

    return (
      <div className="row">
        <div className="col-xl-6">
          <ListView
            config={listViewConf}
            handleDelete={this._handleDelete}
            handleFilterUpdate={this._handleFilterUpdate}
          />
        </div>
        <div className="col-xl-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-map-location" />
                  </span>
                  <h3 className="m-portlet__head-text">
                    {activeEmailTemplate
                      ? "Edit Email Template"
                      : "Create Email Template"}
                  </h3>
                </div>
              </div>
            </div>
            <EmailTemplatesForm
              onSubmit={
                activeEmailTemplate ? this._handleUpdate : this._handleCreate
              }
              isCreating={emailTemplateCreating}
              emailTemplate={activeEmailTemplate}
              event={event}
              emailTemplateTypes={types}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadEmailTemplate: (id, filters) =>
    dispatch(EMAIL_TEMPLATES_ACTIONS.loadRequest(id, filters)),
  loadEmailTemplateTypes: () =>
    dispatch(EMAIL_TEMPLATE_TYPES_ACTIONS.loadAllRequest()),
  resetActive: () => dispatch(EMAIL_TEMPLATES_ACTIONS.resetActive()),
  createEmailTemplate: values =>
    dispatch(EMAIL_TEMPLATES_ACTIONS.createRequest(values)),
  updateEmailTemplate: (id, values) =>
    dispatch(EMAIL_TEMPLATES_ACTIONS.updateRequest(id, values)),
  deleteEmailTemplate: id =>
    dispatch(EMAIL_TEMPLATES_ACTIONS.deleteRequest(id)),
  updateFilters: filters =>
    dispatch(EMAIL_TEMPLATES_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    emailTemplates: selectEmailTemplates(state),
    emailTemplateTypes: selectEmailTemplateTypes(state),
    emailTemplatesLoaded: emailTemplatesLoaded(state),
    emailTemplateCreating: emailTemplateCreating(state),
    emailTemplatesMeta: emailTemplatesMeta(state),
    filters: emailTemplatesFilters(state),
    activeEmailTemplate: selectActiveEmailTemplate(state)
  };
};

const EmailTemplates = connect(
  mapStateToProps,
  mapDispatchToProps
)(_EmailTemplates);

export default EmailTemplates;
